const getSearchColumns = (width: number) => {
    let columns = width < 550 ? 2 : 3;
    columns = width > 767 ? 2 : columns;
    return width > 820 ? 3 : columns;
};

export default getSearchColumns;
